export default function setImportSourceAutoDelivery(ref, autoDelivery) {
	return ref.set({ autoDelivery }, { merge: true });
}
